<template>
  <v-app id="chantal3">
    <v-main>
      <v-container fluid>
        <v-row>
            <v-col cols="5">
              <p>Overview logins in MyBooking using the "new" e-mail code login</p>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="2" class="mt-5">
            Get the bookings after and including
          </v-col>
          <v-col cols="1" class="ma-3">
            <date_picker label=""                                 
                         :date="chantal4BookingDate"
                         field="chantal4BookingDate" 
                         icon="mdi-calendar-month-outline"
                         @updateData="updateData"/> 
          </v-col>
        </v-row>
        <v-row>    
            <v-col cols="1">
              <v-btn class="primary ma-0" small :disabled="results" @click="ovrz">Create excel</v-btn>
            </v-col> 
        </v-row>
      </v-container>
    </v-main>
    <navBar title="Ares - Excel Exports" :home="true" type="excel" />
    <showProgress ref="showProgress"></showProgress>
  </v-app>
</template>

<script>
import navBar from "@/components/ui/navbars/navbar.vue";
import showProgress from "@/components/showProgress.vue";
import date_picker from '@/components/ui/date_picker.vue';

export default {
  components: {
    navBar,
    showProgress,
    date_picker
  },
  data() {
    return {
      results: false,
      chantal4BookingDate: new Date().toISOString(),
      param: {}
    }
  },
  methods: {
    updateData(data){
      console.log('updateData', data);
      this[data.field] = data.value;
    },    
     ovrz() {
      this.results = true;
      this.$refs.showProgress.open();
      this.$axios
        .post("ares/json/ares/task/excel/tmp/chantal4.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "chantal4"
          },
          chantal4: {
            bookdate: this.chantal4BookingDate,
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.items = res.data.chantal4;
            this.$refs.showProgress.close();
            this.results = false;
            window.open(this.items.filename,'_blank');
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },

  }
};

</script> 
